import { render, staticRenderFns } from "./Co46Page.vue?vue&type=template&id=d64663ec"
import script from "./Co46Page.vue?vue&type=script&lang=js"
export * from "./Co46Page.vue?vue&type=script&lang=js"
import style0 from "./Co46Page.vue?vue&type=style&index=0&id=d64663ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports